import type { FC, SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {}

const WhiteAddedCartIcon: FC<Props> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="28"
      viewBox="0 0 28 28"
      fill="none"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.53258 7.94273C2.93527 7.40376 3.52581 7.05263 4.19369 6.95564C4.27963 6.94459 4.33242 6.93599 21.3684 6.92985L21.6471 3.6064C21.6827 3.18774 21.9957 2.84766 22.407 2.77523L24.8932 2.34552C25.3855 2.26327 25.8704 2.59475 25.9576 3.09566C26.0436 3.59658 25.7084 4.07416 25.2075 4.1601L23.4236 4.46826L22.3321 17.4638C22.202 19.0463 20.8589 20.2839 19.2751 20.2839H6.22926C4.70933 20.2839 3.40426 19.1507 3.19064 17.6479L2.05622 9.81378C1.95923 9.14713 2.12866 8.4817 2.53258 7.94273Z"
        fill={props.fill || "currentColor" || "white"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.7894 22.6425C20.623 22.6425 21.3007 23.3202 21.3007 24.1538C21.3007 24.9886 20.623 25.6663 19.7894 25.6663C18.9557 25.6663 18.278 24.9886 18.278 24.1538C18.278 23.3202 18.9557 22.6425 19.7894 22.6425Z"
        fill={props.fill || "currentColor" || "white"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.25539 22.6425C7.08901 22.6425 7.76672 23.3202 7.76672 24.1538C7.76672 24.9886 7.08901 25.6663 6.25539 25.6663C5.42176 25.6663 4.74406 24.9886 4.74406 24.1538C4.74406 23.3202 5.42176 22.6425 6.25539 22.6425Z"
        fill={props.fill || "currentColor" || "white"}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7458 15.5058C11.6587 15.5058 11.5716 15.4725 11.5052 15.4061L10.0165 13.9175C9.88349 13.7844 9.88349 13.5693 10.0165 13.4363C10.1496 13.3033 10.3646 13.3033 10.4977 13.4363L11.7458 14.6844L14.7804 11.6498C14.9135 11.5168 15.1285 11.5168 15.2616 11.6498C15.3946 11.7829 15.3946 11.9979 15.2616 12.131L11.9864 15.4061C11.92 15.4725 11.8329 15.5058 11.7458 15.5058Z"
        fill="#3064C0"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.60389 13.0238C9.24299 13.3847 9.24309 13.9691 9.60389 14.3299ZM9.60389 13.0238C9.96475 12.663 10.5492 12.663 10.91 13.0238L11.7457 13.8594L14.3678 11.2373C14.7286 10.8765 15.313 10.8765 15.6739 11.2373C16.0347 11.5982 16.0347 12.1826 15.6739 12.5434L15.2614 12.1309C15.3945 11.9979 15.3945 11.7828 15.2614 11.6498C15.1284 11.5167 14.9133 11.5167 14.7803 11.6498L11.7457 14.6844L10.4975 13.4363C10.3645 13.3032 10.1494 13.3032 10.0164 13.4363C9.88332 13.5693 9.88332 13.7844 10.0164 13.9174L11.5051 15.4061C11.5705 15.4715 11.6562 15.5049 11.7421 15.5058C11.7433 15.5058 11.7445 15.5058 11.7457 15.5058C11.7469 15.5058 11.7481 15.5058 11.7492 15.5058C11.8352 15.5049 11.9208 15.4715 11.9862 15.4061L15.2614 12.1309L15.6739 12.5434L12.3987 15.8186C12.3987 15.8186 12.3987 15.8186 12.3987 15.8186C12.2188 15.9985 11.9815 16.0891 11.7457 16.0891C11.5098 16.0891 11.2725 15.9985 11.0926 15.8186C11.0926 15.8186 11.0926 15.8186 11.0926 15.8186L9.60389 14.3299"
        fill="#3064C0"
      />
    </svg>
  );
};

export default WhiteAddedCartIcon;
